'use client';

import { ScrollArea } from '@shared/components/shadcn';
import type { FileListProps } from '../types';
import { FileListItem } from './FileListItem';

function FileList({ files, onRemove, disabled = false }: FileListProps) {
  if (files.length === 0) {
    return null;
  }

  return (
    <ScrollArea hideScrollbar className="max-h-full min-h-0 min-w-0 w-full" data-track-container="Documents" data-testid="file-list">
      <div className="flex flex-col gap-3" data-testid="file-list-content">
        {files.map(file => (
          <FileListItem key={file.id} file={file} onRemove={onRemove} disabled={disabled} />
        ))}
      </div>
    </ScrollArea>
  );
}

export { FileList };
